/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'


/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  devices: {
    '& .control': {
      border: '2px solid #E7ECF7 !important',
      height: '42px',
      '&.selected-true': {
        border: '2px solid #3257EC !important'
      }
    }
  }
});
